import { rgb } from 'pdf-lib';
import { DocumentElement } from './document-element.model';

export const DelegationConfiguration: DocumentElement = {
  name: {
    x: 150,
    y: 655,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 133, end: 536 },
  },
  birthDate: {
    x: 150,
    y: 627,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 128, end: 536 },
  },
  birthPlace: {
    x: 150,
    y: 599,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 104, end: 301 },
  },
  birthCity: {
    x: 400,
    y: 599,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 358, end: 536 },
  },
  fiscalCode: {
    x: 150,
    y: 571,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 125, end: 536 },
  },
  residentPlace: {
    x: 150,
    y: 544,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 115, end: 301 },
  },
  residentCity: {
    x: 400,
    y: 544,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 357, end: 536 },
  },
  residentAddress: {
    x: 150,
    y: 516,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 122, end: 536 },
  },
  registerNumber: {
    x: 150,
    y: 488,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 150, end: 301 },
  },
  headquarter: {
    x: 400,
    y: 488,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 396, end: 536 },
  },
  sector: {
    x: 150,
    y: 460,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 150, end: 536 },
  },
  phone: {
    x: 150,
    y: 432,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 105, end: 301 },
  },
  email: {
    x: 400,
    y: 432,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 334, end: 536 },
  },
  subscriptionDate: {
    x: 150,
    y: 255,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 150, end: 301 },
  },
  subscriptionPlace: {
    x: 400,
    y: 255,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 339, end: 536 },
  },
  nameSign: {
    x: 180,
    y: 237,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 36,
    width: 100,
    adjustBy: 'height',
    boundaries: { start: 156, end: 536 },
  },
  subscriberSign: {
    x: 160,
    y: 207,
    rotate: 0,
    size: 30,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'regular',
    height: 35,
    width: 100,
    adjustBy: 'height',
    boundaries: { start: 156, end: 536 },
  },
  delegateName: {
    x: 150,
    y: 146,
    rotate: 0,
    size: 10,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'calibri',
    font: 'bold',
    height: 0,
    width: 0,
    adjustBy: 'height',
    boundaries: { start: 150, end: 536 },
  },
  delegateSign: {
    x: 92,
    y: 111,
    rotate: 0,
    size: 30,
    color: rgb(0, 0, 0),
    page: [0],
    type: 'text',
    family: 'bastliga',
    font: 'regular',
    height: 28,
    width: 100,
    adjustBy: 'height',
    boundaries: { start: 90, end: 536 },
  },
};
